<template>
  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
      <div class="d-flex align-items-start vh-100">
        <div
          class="nav flex-column nav-pills me-3"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
          style="min-width: 250px;"
        >
          <button
            class="nav-link active"
            id="v-pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-home"
            type="button"
            @click="showWalk = true"
          >
            กิจกรรมการเดินภาพรวม
          </button>

          <button
            class="nav-link"
            id="v-pills-profile-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-profile"
            type="button"
            @click="showHand = true"
          >
            กิจกรรมบีบมือภาพรวม
          </button>

          <button
            class="nav-link"
            id="v-pills-messages-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-messages"
            type="button"
          >
            กิจกรรมการเดินสัปดาห์
          </button>

          <button
            class="nav-link"
            id="v-pills-settings-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-settings"
            type="button"
          >
            กิจกรรมบีบมือสัปดาห์
          </button>
        </div>

        <div class="tab-content flex-grow-1 position-relative p-4" id="v-pills-tabContent">
          <!-- กิจกรรมการเดินภาพรวม -->
          <div class="tab-pane fade show active h-200" id="v-pills-home">
            <div v-if="showWalk">
              <div id="walkReport">
                <h4>กิจกรรมการเดินภาพรวม</h4>

                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="form-label">วันที่เริ่มต้น</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.startDate"
                    />
                  </div>

                  <div class="col-md-3">
                    <label class="form-label">วันที่สิ้นสุด</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.endDate"
                    />
                  </div>

                  <div class="col-md-3 d-flex align-items-end">
                    <button class="btn btn-secondary" @click="clearDateFilter">
                      ล้างตัวกรอง
                    </button>
                  </div>
                </div>

                <div>
                  <h5 class="mb-3">
                    {{ currentDisplayLabel }}
                  </h5>

                  <table class="table table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th>ผู้เข้าร่วมโครงการ</th>
                        <th v-for="week in walkTableData.weeks" :key="week">
                          สัปดาห์ที่ {{ week }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="participant in walkTableData.participants"
                        :key="participant.participant_id"
                      >
                        <td @click="goToHistoryWalk(participant)" class="clickable-name">
                          {{ participant.firstname }} {{ participant.lastname }}
                          ({{ participant.random_number }})
                        </td>

                        <td
                          v-for="week in walkTableData.weeks"
                          :key="week"
                          class="text-center"
                        >
                          <span v-if="participant.weeks[week].passed">⭐</span>
                          <span v-else>{{ participant.weeks[week].total }}/5</span>
                        </td>
                      </tr>

                      <tr v-if="walkTableData.participants.length === 0">
                        <td :colspan="walkTableData.weeks.length + 1" class="text-center">
                          ไม่พบข้อมูล{{ noDataLabel }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- กิจกรรมบีบมือภาพรวม -->
          <div class="tab-pane fade" id="v-pills-profile">
            <div v-if="showHand">
              <div id="handReport">
                <h4>กิจกรรมการบีบมือภาพรวม</h4>

                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="form-label">วันที่เริ่มต้น</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.startDate"
                    />
                  </div>

                  <div class="col-md-3">
                    <label class="form-label">วันที่สิ้นสุด</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.endDate"
                    />
                  </div>

                  <div class="col-md-3 d-flex align-items-end">
                    <button class="btn btn-secondary" @click="clearDateFilter">
                      ล้างตัวกรอง
                    </button>
                  </div>
                </div>

                <div>
                  <h4>{{ currentDisplayLabel }}</h4>

                  <table class="table table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th>ผู้เข้าร่วมโครงการ</th>
                        <th>สัปดาห์ 1</th>
                        <th>สัปดาห์ 2</th>
                        <th>สัปดาห์ 3</th>
                        <th>สัปดาห์ 4</th>
                        <th>สัปดาห์ 5</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="participant in tableDataMonth"
                        :key="participant.participant_id"
                      >
                        <td @click="goToHistoryHand(participant)" class="clickable-name">
                          {{ participant.firstname }} {{ participant.lastname }}
                          ({{ participant.random_number }})
                        </td>

                        <td v-for="week in 5" :key="week" class="text-center">
                          <span v-if="participant.weeks[week].passed">⭐</span>
                          <span v-else>{{ participant.weeks[week].total }}/3</span>
                        </td>
                      </tr>

                      <tr v-if="tableDataMonth.length === 0">
                        <td :colspan="6" class="text-center">
                          ไม่พบข้อมูล{{ noDataLabel }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- กิจกรรมการเดินสัปดาห์ -->
          <div class="tab-pane fade" id="v-pills-messages">
            <h4>กิจกรรมการเดินรายสัปดาห์ของผู้ร่วมโครงการ</h4>

            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th>ผู้เข้าร่วมโครงการ</th>
                  <th v-for="(n, index) in walk.finish_number_per_week" :key="index">
                    วันที่ {{ index + 1 }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="p in weeklyParticipants" :key="p.participant_id">
                  <td>
                    {{ p.firstname }} {{ p.lastname }} ({{ p.random_number }})
                  </td>

                  <td
                    v-for="(day, index) in walk.finish_number_per_week"
                    :key="index"
                    class="text-center"
                  >
                    <span v-if="p.days[day]">⭐</span>
                    <span v-else>-</span>
                  </td>
                </tr>

                <tr v-if="weeklyParticipants.length === 0">
                  <td :colspan="walk.finish_number_per_week + 1" class="text-center">
                    ไม่พบข้อมูลในสัปดาห์นี้
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- กิจกรรมบีบมือสัปดาห์ -->
          <div class="tab-pane fade" id="v-pills-settings">
            <h4>กิจกรรมการบีบมือรายสัปดาห์ของผู้ร่วมโครงการ</h4>

            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th>ผู้เข้าร่วมโครงการ</th>
                  <th v-for="(n, index) in hand.finish_number_per_week" :key="index">
                    วันที่ {{ index + 1 }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="participant in weeklyTableData" :key="participant.participant_id">
                  <td>
                    {{ participant.firstname }} {{ participant.lastname }}
                    ({{ participant.random_number }})
                  </td>

                  <td
                    v-for="(day, index) in hand.finish_number_per_week"
                    :key="index"
                    class="text-center"
                  >
                    <span v-if="participant.days[day] && participant.days[day].passed">⭐</span>
                    <span v-else>-</span>
                  </td>
                </tr>

                <tr v-if="weeklyTableData.length === 0">
                  <td :colspan="hand.finish_number_per_week + 1" class="text-center">
                    ไม่พบข้อมูลในสัปดาห์นี้
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantsActivitiesService from "../services/ParticipantsActivitiesService";
import ActivitiesService from "../services/ActivitiesService";
import UserService from "../services/UserService";

export default {
  name: "Nav",
  components: {},
  props: {
    msg: String,
  },
  data() {
    return {
      walk: {},
      showWalk: true,
      showHand: true,
      countByWeekWalk: [],
      walkActivities: [],
      handActivities: [],
      hand: {},
      filters: {
        startDate: "",
        endDate: "",
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;

    UserService.getUser(id).then(
      (response) => {
        if (response.status === 200) {
          localStorage.setItem("usernilin", JSON.stringify(response.data));
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.getWalk();
    this.getHand();

    ParticipantsActivitiesService.get_participants_activitie(1).then(
      (response) => {
        if (response.status === 200) {
          this.walkActivities = response.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );

    ParticipantsActivitiesService.get_participants_activitie(2).then(
      (response) => {
        if (response.status === 200) {
          this.handActivities = response.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  },
  methods: {
    goToHistoryWalk(participant) {
  const route = this.$router.resolve({
    name: "ParticipantView",
    params: {
      id: participant.participant_id,
      type: 1,
    },
  });

  window.open(route.href, "_blank");
},

goToHistoryHand(participant) {
  const route = this.$router.resolve({
    name: "ParticipantView",
    params: {
      id: participant.participant_id,
      type: 2,
    },
  });

  window.open(route.href, "_blank");
},

    getHand() {
      ActivitiesService.getactivity(2).then((res) => {
        this.hand = res.data;
      });
    },

    getWalk() {
      ActivitiesService.getactivity(1).then((res) => {
        this.walk = res.data;
      });
    },

    getWeekOfMonth(dateStr) {
      const date = new Date(dateStr);
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      return Math.ceil((date.getDate() + firstDay.getDay()) / 7);
    },

    checkWeekPassed(records) {
      if (!records || !records.length) {
        return { passed: false, total: 0 };
      }

      const roundStatus = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
      };

      records.forEach((record) => {
        const round = Number(record.round);

        if (round >= 1 && round <= 5 && record.is_success !== null) {
          roundStatus[round] = true;
        }
      });

      const total = Object.values(roundStatus).filter(Boolean).length;

      return {
        passed: total === 5,
        total,
      };
    },

    getCurrentWeekRange() {
      const now = new Date();
      const day = now.getDay();
      const start = new Date(now);

      start.setHours(0, 0, 0, 0);
      start.setDate(now.getDate() - day);

      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);

      return { start, end };
    },

    getDayIndex(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDay();

      if (day === 0) return 1;
      if (day === 1) return 2;
      if (day === 2) return 3;
      if (day === 3) return 4;
      if (day === 4) return 5;

      return null;
    },

    formatDateKey(dateStr) {
      const d = new Date(dateStr);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    checkDayPassed(records) {
      if (!records || !records.length) {
        return false;
      }

      const roundMap = {};

      records.forEach((record) => {
        const round = Number(record.round);

        if (!roundMap[round]) {
          roundMap[round] = [];
        }

        roundMap[round].push(record);
      });

      return Object.values(roundMap).some((roundRecords) => {
        const sets = [
          ...new Set(roundRecords.map((item) => Number(item.set_of_activities))),
        ].sort((a, b) => a - b);

        const set4Record = roundRecords.find(
          (item) => Number(item.set_of_activities) === 4
        );

        return (
          JSON.stringify(sets) === JSON.stringify([1, 2, 3, 4]) &&
          !!(set4Record && set4Record.is_success)
        );
      });
    },

    checkWeekThreeRounds(records) {
      if (!records || !records.length) {
        return { passed: false, total: 0 };
      }

      const roundMap = {};

      records.forEach((record) => {
        const round = Number(record.round);

        if (!roundMap[round]) {
          roundMap[round] = [];
        }

        roundMap[round].push(record);
      });

      let totalPassedRounds = 0;

      Object.keys(roundMap).forEach((roundKey) => {
        const roundRecords = roundMap[roundKey];

        const sets = roundRecords
          .map((item) => Number(item.set_of_activities))
          .sort((a, b) => a - b);

        const uniqueSets = [...new Set(sets)];

        const hasCompleteSet =
          JSON.stringify(uniqueSets) === JSON.stringify([1, 2, 3, 4]);

        const set4Record = roundRecords.find(
          (item) => Number(item.set_of_activities) === 4
        );

        const set4Finished = !!(set4Record && set4Record.is_success);

        if (hasCompleteSet && set4Finished) {
          totalPassedRounds++;
        }
      });

      return {
        passed: totalPassedRounds === 3,
        total: totalPassedRounds,
      };
    },

    isInSelectedRange(dateStr) {
      const recordDate = new Date(dateStr);
      recordDate.setHours(0, 0, 0, 0);

      const { startDate, endDate } = this.filters;

      if (startDate || endDate) {
        let start = null;
        let end = null;

        if (startDate) {
          start = new Date(startDate);
          start.setHours(0, 0, 0, 0);
        }

        if (endDate) {
          end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
        }

        if (start && recordDate < start) return false;
        if (end && recordDate > end) return false;

        return true;
      }

      const now = new Date();
      return (
        recordDate.getMonth() === now.getMonth() &&
        recordDate.getFullYear() === now.getFullYear()
      );
    },

    clearDateFilter() {
      this.filters.startDate = "";
      this.filters.endDate = "";
    },
  },
  computed: {
    weekRange() {
      const now = new Date();

      const start = new Date(now);
      start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate() - start.getDay());

      const end = new Date(start);
      end.setDate(end.getDate() + 6);
      end.setHours(23, 59, 59, 999);

      return { start, end };
    },

    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },

    currentUser() {
      return this.$store.state.auth.user;
    },

    currentMonthLabel() {
      const now = new Date();
      return now.toLocaleDateString("th-TH", {
        month: "long",
        year: "numeric",
      });
    },

    currentDisplayLabel() {
      if (this.filters.startDate || this.filters.endDate) {
        const start = this.filters.startDate || "-";
        const end = this.filters.endDate || "-";
        return `วันที่ ${start} ถึง ${end}`;
      }

      return `เดือน ${this.currentMonthLabel}`;
    },

    noDataLabel() {
      if (this.filters.startDate || this.filters.endDate) {
        return "ในช่วงวันที่ที่เลือก";
      }
      return "ในเดือนปัจจุบัน";
    },

    tableDataMonth() {
      const participants = {};

      const filteredRecords = this.handActivities.filter((record) => {
        return this.isInSelectedRange(record.started_at);
      });

      filteredRecords.forEach((record) => {
        const participantId = record.participant_id;
        const week = this.getWeekOfMonth(record.started_at);

        if (!participants[participantId]) {
          participants[participantId] = {
            participant_id: participantId,
            firstname: record.firstname,
            lastname: record.lastname,
            random_number: record.random_number,
            weeks: {
              1: { passed: false, total: 0 },
              2: { passed: false, total: 0 },
              3: { passed: false, total: 0 },
              4: { passed: false, total: 0 },
              5: { passed: false, total: 0 },
            },
            weekRecords: {
              1: [],
              2: [],
              3: [],
              4: [],
              5: [],
            },
          };
        }

        if (week >= 1 && week <= 5) {
          participants[participantId].weekRecords[week].push(record);
        }
      });

      Object.values(participants).forEach((participant) => {
        [1, 2, 3, 4, 5].forEach((week) => {
          const result = this.checkWeekThreeRounds(participant.weekRecords[week]);
          participant.weeks[week] = result;
        });
      });

      return Object.values(participants);
    },

    walkTableData() {
      const monthRecords = this.walkActivities.filter((record) => {
        return this.isInSelectedRange(record.started_at);
      });

      const participantMap = {};

      monthRecords.forEach((record) => {
        const participantId = record.participant_id;
        const week = this.getWeekOfMonth(record.started_at);

        if (!participantMap[participantId]) {
          participantMap[participantId] = {
            participant_id: participantId,
            random_number: record.random_number,
            firstname: record.firstname,
            lastname: record.lastname,
            weeks: {},
          };

          for (let i = 1; i <= 5; i++) {
            participantMap[participantId].weeks[i] = {
              passed: false,
              total: 0,
              records: [],
            };
          }
        }

        if (week >= 1 && week <= 5) {
          participantMap[participantId].weeks[week].records.push(record);
        }
      });

      Object.values(participantMap).forEach((participant) => {
        for (let week = 1; week <= 5; week++) {
          const result = this.checkWeekPassed(participant.weeks[week].records);
          participant.weeks[week].passed = result.passed;
          participant.weeks[week].total = result.total;
        }
      });

      return {
        weeks: [1, 2, 3, 4, 5],
        participants: Object.values(participantMap),
      };
    },

    weeklyParticipants() {
      const weekRange = this.getCurrentWeekRange();
      const participantMap = {};

      const weekRecords = this.walkActivities.filter((record) => {
        const date = new Date(record.started_at);
        return date >= weekRange.start && date <= weekRange.end;
      });

      weekRecords.forEach((record) => {
        const pid = record.participant_id;
        const dayIndex = this.getDayIndex(record.started_at);

        if (!participantMap[pid]) {
          participantMap[pid] = {
            participant_id: pid,
            firstname: record.firstname,
            lastname: record.lastname,
            random_number: record.random_number,
            days: { 1: false, 2: false, 3: false, 4: false, 5: false },
          };
        }

        if (record.is_success && dayIndex >= 1 && dayIndex <= 5) {
          participantMap[pid].days[dayIndex] = true;
        }
      });

      return Object.values(participantMap);
    },

    weeklyTableData() {
      const { start, end } = this.getCurrentWeekRange();
      const participants = {};

      const weekRecords = this.handActivities
        .filter((record) => {
          const date = new Date(record.started_at);
          return date >= start && date <= end;
        })
        .sort((a, b) => new Date(a.started_at) - new Date(b.started_at));

      weekRecords.forEach((record) => {
        const pid = record.participant_id;
        const dateKey = this.formatDateKey(record.started_at);

        if (!participants[pid]) {
          participants[pid] = {
            participant_id: pid,
            firstname: record.firstname,
            lastname: record.lastname,
            random_number: record.random_number,
            groupedDays: {},
            days: {
              1: { passed: false },
              2: { passed: false },
              3: { passed: false },
              4: { passed: false },
              5: { passed: false },
            },
          };
        }

        if (!participants[pid].groupedDays[dateKey]) {
          participants[pid].groupedDays[dateKey] = [];
        }

        participants[pid].groupedDays[dateKey].push(record);
      });

      Object.values(participants).forEach((participant) => {
        const sortedDateKeys = Object.keys(participant.groupedDays)
          .sort()
          .slice(0, 5);

        sortedDateKeys.forEach((dateKey, index) => {
          const dayIndex = index + 1;
          const records = participant.groupedDays[dateKey];

          participant.days[dayIndex] = {
            passed: this.checkDayPassed(records),
          };
        });
      });

      return Object.values(participants);
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #ccc;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
}

.star {
  font-size: 24px;
  margin-top: 8px;
}

.clickable-name {
  cursor: pointer;
}

.clickable-name:hover {
  text-decoration: underline;
}
</style>